var render, staticRenderFns
import script from "./PieChart.vue?vue&type=script&lang=js&"
export * from "./PieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355a980a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('355a980a')) {
      api.createRecord('355a980a', component.options)
    } else {
      api.reload('355a980a', component.options)
    }
    
  }
}
component.options.__file = "src/modules/charts/PieChart.vue"
export default component.exports